// Run low-priority work off the critical path so it never blocks paint or
// user interaction. Prefer ``requestIdleCallback`` (runs when the main thread
// is idle) and fall back to a macrotask (``setTimeout 0``) where it's missing
// (Safari < 17, jsdom). The ``timeout`` guarantees the callback still fires
// under sustained load instead of starving forever.
type IdleDeadlineLike = { didTimeout: boolean; timeRemaining: () => number };

interface IdleCapableWindow {
  requestIdleCallback?: (
    cb: (deadline: IdleDeadlineLike) => void,
    opts?: { timeout: number }
  ) => number;
}

export function deferIdle(fn: () => void, timeout = 2000): void {
  const ric =
    typeof window !== 'undefined'
      ? (window as IdleCapableWindow).requestIdleCallback
      : undefined;
  if (ric) {
    ric(() => fn(), { timeout });
  } else {
    setTimeout(fn, 0);
  }
}
